<template>
    <div class="mt-4" v-if="details" >
        <div>
            <p> {{details.description}}</p>
            <p><a :href="details.website" target="_blank">{{details.website}}</a></p>
            <p>{{details.booking_instructions}}</p>
        </div>
        <div>
            <p><strong>Payment Options</strong></p>
            <div class="d-flex">
                <span v-for="(option, index ) in details.payment_options" :key="index" class="mr-2">
                   <p class="payment-option">{{option}}  <span v-if="index+1 != details.payment_options.length">, </span> </p>
                </span>
            </div>
        </div>
        <div class="provider-buttons mb-2">
            <div v-if="details.booking_phone_number">
                <a :href="'tel:' + details.booking_phone_number" class="btn btn-outline-secondary provider-btn-type mb-2">
                    <svg-icon :name="this.brand + '/phone'" width="24"></svg-icon> Call provider
                </a>
            </div>
            <div v-if="details.booking_email">
                <a :href="'mailto:' + details.booking_email" class="btn btn-outline-secondary provider-btn-type mb-2">
                    <svg-icon :name="this.brand + '/email'" width="24" height="10px"></svg-icon> Email provider
                </a>
            </div>
            <div v-if="details.booking_website">
                <button @click="goToBookingWebsite()" class="btn btn-outline-secondary provider-btn-type">
                    <svg-icon :name="this.brand + '/booking'" width="24" height="20"></svg-icon> Book online
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'

const whitelabel = require('../../whitelabel.config')[process.env.VUE_APP_BRAND]

export default {
    data() {
        return {
            brand: whitelabel.brand,
        }
    },
    props: {
        details: {
            type: Object,
        },
    },
    computed: {
        ...mapState([
            'currentJourney',
        ]),
    },
    methods: {
        goToBookingWebsite() {
            window.open(this.details.booking_website)
        },
    },
}
</script>
